<template>
  <div class="subject app-container">
    <tabHeader
      :slideData="slideData"
      :tab="tab"
      @headerTabBack="headerTabBack"
    />
    <div class="subject-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tabHeader from "@/components/tabHeader";
export default {
  components: {
    tabHeader
  },
  computed: {
    slideData() {
      const slideData = [
        {
          name: this.$t("content.books.stack"),
          component: "stack"
        },
        {
          name: this.$t("content.books.group"),
          component: "list"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: this.$route.name || "stack"
    };
  },
  methods: {
    headerTabBack(tab) {
      if (this.$store.state.selectShow) {
        this.$store.dispatch("setSelectShow", false);
        this.$store.dispatch("setOverallShow", false);
        this.$store.dispatch("setHandleShow", " ");

        this.tab = tab.component;
        this.$router.push({ name: tab.component });
      } else {
        this.tab = tab.component;
        this.$router.push({ name: tab.component });
      }
    }
  },
  watch: {
    $route(news, olds) {
      if (this.$route.name) {
        this.tab = this.$route.name;
      }
    }
  },
  mounted() {
    this.tab = this.$route.name;
  }
};
</script>

<style lang="scss" scoped>
.subject-container {
  flex: 1;
  display: flex;
  overflow: hidden;
}
</style>
